export default function PHP_ftp_exec() {
  return (
    <div>
      <h1>PHP_ftp_exec</h1>
    </div>
  );
}
